import { Box } from '@mui/material';
import AIHSCodeLabeling from 'src/features/Public/AIHSCodeLabeling';
import PublicPageContainer from 'src/features/Public/PublicPageContainer';

const AiHSCodeLabelingPublicPage = () => {
  return (
    <PublicPageContainer featureName={'AI HS Code Labeling'}>
      <center>
        <Box p={5} maxWidth={1024}>
          <AIHSCodeLabeling />
        </Box>
      </center>
    </PublicPageContainer>
  );
};

export default AiHSCodeLabelingPublicPage;
